import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesLeft, faAnglesRight, faUser, faKey } from '@fortawesome/free-solid-svg-icons';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Form, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

import { useTheme } from './themeControl/ThemeProvider';
import { useAlert } from '../providers/AlertProvider';
import { useAuthProvider } from '../providers/AuthProvider';

import { ActivityIndicator } from '../components/custom/ActivityIndicator';

// Api
import { fetch_all_vehicles } from '../api/vehicles';
import { changePassword } from '../api/profiles';

// import css
import './css/GlobalStyles.css';
import './css/DriversStyles.css';
import './css/LeftNavigation.css';
import './css/LeftNavigation.css';
import './css/Styles.css';

// import images
import './img/light-driver.png';
import './img/dark-driver.png';
import './img/light-admin.png';
import './img/dark-admin.png';
import './img/light-service.png';
import './img/dark-service.png';
import './img/edit.png';
import './img/padlock.png';
import './img/unlock.png';
import logger from "../utils/logger";


const ProfilePage = () => {
    const { theme } = useTheme();
    const { showAlert } = useAlert();
    const { profile, loggedIn } = useAuthProvider();

    // loading state
    const [isLoading, setIsLoading] = useState(false);    

    // State to manage active tab
    const [activeTab, setActiveTab] = useState('info');
    const [showLeftNav, setShowLeftNav] = useState(false);

    const [allVehicles, setAllVehicles] = useState(null);

    // fetch vehicles from database
    const fecthVehicles = async () => {
        setIsLoading(true);
        const { data: vehicleData } = await fetch_all_vehicles();
        setAllVehicles(vehicleData || []);
        setIsLoading(false);
    }

    // Functions to update password ----------------------------------------------------------------------------------------------
    const {register, handleSubmit, reset, formState:{errors}} = useForm();

    useEffect(() => {
        fecthVehicles();
    }, []);

    if (!loggedIn) {
        return (
            <div style={{ textAlign: 'center', marginTop: '30vh', height: '100vh', color: 'red' }}>
                <h3>Unauthorised Access</h3>
                <p>You must be logged in to view this page</p>
            </div>
        );
    }

    const submitForm = async (data) => {
        setIsLoading(true);
    
        if (data.password !== data.confirmPassword) {
            setIsLoading(false);
            showAlert({
                message: 'Passwords do not match',
                type: 'danger',
                buttons: [{ label: 'Close' }],
            });
            reset();
            return;
        }
    
        const body = {
            currentPassword: data.currentPassword,
            password: data.password,
            email: profile.email,
        };
    
        try {
            const { status, responseBody } = await changePassword(body);
    
            if (status === 200 || status === 201) {
                setIsLoading(false);
                showAlert({
                    message: responseBody.message || 'Password Updated Successfully',
                    type: 'success',
                    buttons: [{ label: 'Close' }],
                });
            } else {
                setIsLoading(false);
                showAlert({
                    message: responseBody.error || 'Failed to update account',
                    type: 'danger',
                    buttons: [{ label: 'Retry', type: 'danger' }],
                });
            }
        } catch (err) {
            setIsLoading(false);
            logger.error('Fetch error:', err);
            showAlert({
                message: `Error: ${err.message || 'Error Updating Account!'}`,
                type: 'danger',
                buttons: [{ label: 'Retry', type: 'danger' }],
            });
        } finally {
            reset();
        }
    };
    
    return (
        <div id={theme} className="container-fluid closed-drivers-container">

            <Row>
                {/* Left Navigation Panel */}
                <Col className={showLeftNav ? "left-nav" : "closed-nav"} style={{ height: '100vh', paddingBottom: '150px' }} onMouseEnter={() => setShowLeftNav(true)} onMouseLeave={() => setShowLeftNav(false)}>
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0, width: '100%' }}>
                        <li title="Profile Info" className={`nav-item ${activeTab === 'info' ? 'active' : ''}`} style={{ cursor: isLoading ? 'not-allowed' : 'pointer', background: activeTab === 'info' ? 'rgba(25, 151, 235, 0.8)' : 'transparent' }} onClick={!isLoading ? () => setActiveTab('info') : null}><FontAwesomeIcon icon={faUser} style={{ width: 16, flexShrink: 0 }} />{showLeftNav && <span>Profile Info</span>}</li>
                        <li title="Change Password" className={`nav-item ${activeTab === 'password' ? 'active' : ''}`} style={{ cursor: isLoading ? 'not-allowed' : 'pointer', background: activeTab === 'password' ? 'rgba(25, 151, 235, 0.8)' : 'transparent' }} onClick={!isLoading ? () => setActiveTab('password') : null}><FontAwesomeIcon icon={faKey} style={{ width: 16, flexShrink: 0 }} />{showLeftNav && <span>Change Password</span>}</li>
                    </ul>
                </Col>

                {/* Right Content Panel */}
                <Col className="closed-nav-content" style={{ padding: '20px' }}>
                    {isLoading ? (
                        <div style={{ alignSelf: 'center', justifyContent: 'center', marginTop: '30vh' }}>
                            <ActivityIndicator />
                        </div>
                    ) : (
                        <>
                            {/* Right Profile Info */}
                            <div className="accounts-container">
                                {/* Profile Information */}
                                {activeTab === 'info' && (
                                    profile ? (
                                    <>
                                    <div style={{ textAlign: 'center' }}>
                                        <h3>Profile Information</h3>
                                    </div>
                                
                                    <div style={{ alignSelf: 'flex-start', margin: '100px' }}>
                                        <h5><strong>Account Details</strong></h5>
                                        <p><strong>Name:</strong> {profile.name} {profile.surname}</p>
                                        <p><strong>Email:</strong> {profile.email}</p>
                                        <p><strong>Phone:</strong> {profile.phone}</p>
                                        <p><strong>Address:</strong> {profile.address}</p>

                                        {profile.licence && (
                                            <>
                                                <p><strong>Licence No:</strong> {profile.licence}</p>
                                                <p><strong>Licence Exp:</strong> {profile.licence_expiry}</p>
                                            </>
                                        )}
                                        {profile.licence_check && (
                                            <p><strong>Licence Check:</strong> {profile.licence_check}</p>
                                        )}
                                        {profile.tacho_expiry && (
                                            <p><strong>Tacho Exp:</strong> {profile.tacho_expiry}</p>
                                        )}
                                        {profile.cpc_expiry && (
                                            <p><strong>CPC Exp:</strong> {profile.cpc_expiry}</p>
                                        )}
                                        {profile.adr_expiry && (
                                            <p><strong>ADR Exp:</strong> {profile.adr_expiry}</p>
                                        )}
                                        {profile.truck_id && (
                                            <p>
                                                <strong>Vehicle:</strong>{' '}
                                                {allVehicles?.find((vehicle) => vehicle.id === profile.truck_id)?.reg || 'Vehicle not found'}
                                            </p>
                                        )}
                                        <p style={{ color: profile.status === 'active' ? 'green' : 'red' }}>
                                            <strong>Status:</strong> {profile.status}
                                        </p>
                                    </div>
                                    </>
                                    ) : (
                                    <div style={{ textAlign: 'center' }}>
                                        <h3>No Profile Found</h3>
                                    </div>
                                    ))}
                            </div>

                            {/* Change Password Form */}
                            {activeTab === 'password' && (
                                <>
                                    <div style={{ textAlign: 'center' }}>
                                        <h3>Change Password</h3>
                                    </div>
                                    <form onSubmit={handleSubmit(submitForm)}>
                                        {/* Current Password */}
                                        <Form.Group className="signup-form" style={{ marginTop: '150px' }}>
                                            <Form.Label>Current Password</Form.Label>
                                            <Form.Control
                                                type="password"
                                                placeholder="Current Password"
                                                {...register('currentPassword', { required: true })}
                                            />
                                        </Form.Group>
                                        {errors.currentPassword && (
                                            <div className="signup-error-container">
                                                <p className="signup-errors"><small>Input your current password</small></p>
                                            </div>
                                        )}

                                        {/* New Password */}
                                        <Form.Group className="signup-form">
                                            <Form.Label>New Password</Form.Label>
                                            <Form.Control
                                                type="password"
                                                placeholder="New Password"
                                                {...register('password', { required: true, minLength: 8 })}
                                            />
                                        </Form.Group>
                                        {errors.password && (
                                            <div className="signup-error-container">
                                                <p className="signup-errors"><small>Password is required</small></p>
                                                {errors.password.type === 'minLength' && (
                                                    <p className="signup-errors"><small>Min length 8 characters</small></p>
                                                )}
                                            </div>
                                        )}

                                        {/* Confirm Password */}
                                        <Form.Group className="signup-form">
                                            <Form.Label>Confirm Password</Form.Label>
                                            <Form.Control
                                                type="password"
                                                placeholder="Confirm Password"
                                                {...register('confirmPassword', { required: true, minLength: 8 })}
                                            />
                                        </Form.Group>
                                        {errors.confirmPassword && (
                                            <div className="signup-error-container">
                                                <p className="signup-errors"><small>Confirmation is required</small></p>
                                                {errors.confirmPassword.type === 'minLength' && (
                                                    <p className="signup-errors"><small>Min length 8 characters</small></p>
                                                )}
                                            </div>
                                        )}

                                        {/* Submit Button */}
                                        <Form.Group>
                                            <div className="signup-button-container">
                                                <Button type="submit" variant="primary">Update Password</Button>
                                            </div>
                                        </Form.Group>
                                    </form>
                                </>
                            )}
                        </>
                    )}
                </Col>

            </Row>
        </div>
    );
};

export default ProfilePage;
